import styled from 'styled-components';

const EmptyContentDiv = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export default EmptyContentDiv;
